module.exports = __webpack_public_path__ + "./img/logo.d5799b24345d8450add3942db327a979.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/logo.png
// module id = ./public/img/logo.png
// module chunks = 0